import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * GoogleAnalytics component - Dynamically loads GA4 script based on admin settings
 * Place this component once in App.js or Layout component
 */
const GoogleAnalytics = () => {
  const [gaId, setGaId] = useState(null);

  useEffect(() => {
    const fetchAnalyticsConfig = async () => {
      try {
        const response = await axios.get(`${API}/site-settings/public/analytics`);
        if (response.data.analytics_enabled && response.data.ga_measurement_id) {
          setGaId(response.data.ga_measurement_id);
        }
      } catch (error) {
        // Silently fail - analytics is optional
        console.debug('Analytics config not available');
      }
    };

    fetchAnalyticsConfig();
  }, []);

  useEffect(() => {
    if (!gaId) return;

    // Check if GA script is already loaded
    if (window.gtag) {
      window.gtag('config', gaId);
      return;
    }

    // Load GA script dynamically
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    
    gtag('js', new Date());
    gtag('config', gaId);

    console.info(`Google Analytics initialized: ${gaId}`);

    // Cleanup function
    return () => {
      // Note: We don't remove the script on unmount as it could affect tracking
    };
  }, [gaId]);

  // This component doesn't render anything
  return null;
};

export default GoogleAnalytics;
